import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  verifyIfscApi,
  getBankAccountInfoApi,
  getGstInfo,
  verifyPanApi,
  getPanAadharLinkStatusApi,
  verifyTanApi,
} from "../../apis/servicesApi";
import {
  getBankAccountNumberType,
  getGstInfoType,
  getIfscDataType,
  getPanAadharLinkStatusType,
  verifyPanType,
  verifyTanType,
} from "../../commonTypes/serviceTypes";

export const verifyIfscAction = createAsyncThunk(
  "services/verifyIfsc",
  async (data: getIfscDataType) => {
    const response = await verifyIfscApi(data);
    return response.data;
  }
);

export const getGstInfoAction = createAsyncThunk(
  "services/getGstInfo",
  async (data: getGstInfoType) => {
    const response = await getGstInfo(data);
    return response.data;
  }
);

export const panAadharLinkStatusAction = createAsyncThunk(
  "services/getPanAadharLinkStatus",
  async (data: getPanAadharLinkStatusType) => {
    const response = await getPanAadharLinkStatusApi(data);
    return response.data;
  }
);

export const getBankAccountInfoAction = createAsyncThunk(
  "services/getBankAccountInfo",
  async (data: getBankAccountNumberType) => {
    const response = await getBankAccountInfoApi(data);
    return response.data;
  }
);

export const verifyPanAction = createAsyncThunk(
  "services/verifyPan",
  async (data: verifyPanType) => {
    const response = await verifyPanApi(data);
    return response.data;
  }
);
export const authorizedVerifyPanAction = createAsyncThunk(
  "services/authorizes/verifyPan",
  async (data: verifyPanType) => {
    const response = await verifyPanApi(data);
    return response.data;
  }
);

export const verifyShippingAddressPanAction = createAsyncThunk(
  "services/verifyShippingAddressPan",
  async (data: verifyPanType) => {
    const response = await verifyPanApi(data);
    return response.data;
  }
);

export const verifyTanAction = createAsyncThunk(
  "services/verifyTan",
  async (data: verifyTanType) => {
    const response = await verifyTanApi(data);
    return response.data;
  }
);
